import { PaymentMethodEnum } from '@/types/common';
import type { ICheckoutContext } from '@/types/context';

type BootTransitionContext = Pick<ICheckoutContext, 'paymentMethodSelected' | 'template'>;

export const shouldDeferBootContentEnter = (context?: BootTransitionContext | null): boolean =>
  Boolean(
    context?.template.features.deferExpressWalletReveal && context.paymentMethodSelected === PaymentMethodEnum.APPLE_PAY
  );

let suppressNextTemplateTransition = false;

export const suppressNextCheckoutTemplateTransition = (): void => {
  suppressNextTemplateTransition = true;
};

export const consumeSuppressNextCheckoutTemplateTransition = (): boolean => {
  const shouldSuppress = suppressNextTemplateTransition;
  suppressNextTemplateTransition = false;
  return shouldSuppress;
};
